var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonthlyEmiAmount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.763,
    height: 18,
    viewBox: "0 0 17.763 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22379",
    "data-name": "Group 22379",
    transform: "translate(-5606.72 1041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29069",
    "data-name": "Path 29069",
    d: "M14.674,6.339V2.553A1.022,1.022,0,0,0,13.652,1.53H2.743A1.023,1.023,0,0,0,1.72,2.553V17.1a1.023,1.023,0,0,0,1.023,1.023H8.772c0-.05-.009-.1-.009-.151V15.849H4.107V14.713H8.764v-2.5H4.107V11.076H8.764V9A2.584,2.584,0,0,1,8.8,8.576h-4.7V7.44H9.275a2.658,2.658,0,0,1,2.151-1.1h3.248ZM4.107,4.94V3.8h8.181V4.94Z",
    transform: "translate(5605 -1042.53)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29070",
    "data-name": "Path 29070",
    d: "M22.873,11.031h-6.5a1.56,1.56,0,0,0-1.561,1.56v8.971a1.561,1.561,0,0,0,1.561,1.56h6.5a1.56,1.56,0,0,0,1.56-1.56V12.591A1.56,1.56,0,0,0,22.873,11.031ZM17.82,21.22H16.437V19.9H17.82Zm0-2.341H16.437V17.564H17.82Zm2.5,2.341H18.933V19.9h1.382Zm0-2.341H18.933V17.564h1.382Zm2.5,2.341H21.429V19.9h1.383Zm0-2.341H21.429V17.564h1.383Zm0-3.217a.39.39,0,0,1-.39.39H16.828a.39.39,0,0,1-.39-.39V13.322a.39.39,0,0,1,.39-.391h5.594a.39.39,0,0,1,.39.391v2.341Z",
    transform: "translate(5600.05 -1046.122)",
    fill: "#170A33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyEmiAmount);
export default __webpack_public_path__ + "static/media/MonthlyEmiAmount.4a15ffc78f1ff3c0ea7babf2e13bb749.svg";
export { ForwardRef as ReactComponent };